import React, { useEffect, useState, useLayoutEffect } from 'react';
import WorkflowListDumb from './WorkflowListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useList, useTemplate, useJob } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { Alert, ModalAlert, ErrorScreen, ModalJobAlert } from 'components/common';
import { CircularProgress, Backdrop } from '@mui/material';
import withRequest from 'hoc/withRequest';
import { JobSchema } from 'schemas';
import { ROUTES } from 'consts';

const WorkflowListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const { getContentList, content, error, isLoaded } = useList('templates');
  const history = useHistory();
  const template = useTemplate();
  const job = useJob();
  const location = useLocation();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalRunJob, setOpenModalRunJob] = useState(false);
  const [workflowSelected, setWorkflowSelected] = useState(null);
  let { search, project=filters.project } = queryString.parse(props.location.search);
  const [runError, setRunError] = useState(0);
  const [customError, setCustomError] = useState("");

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          search,
          projectId: project,
          type: 'WF',
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.WORKFLOW_LIST}?project=${data.project}`;
    if (data?.search) routeToPush += `&search=${data.search.trim()}`;
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    template.cleanUpMessage();
    history.push(ROUTES.WORKFLOW_CREATE);
  };

  const handleEdit = (workflow) => {
    template.cleanUpMessage();
    const { worktemplate_id } = workflow;
    history.push(`${ROUTES.WORKFLOW_EDIT}/${worktemplate_id}`);
  };

  const handleView = (workflow) => {
    template.cleanUpMessage();
    const { worktemplate_id } = workflow;
    history.push(`${ROUTES.WORKFLOW_VIEW}/${worktemplate_id}`);
  };



  const handleDelete = () => {
    const { worktemplate_id } = workflowSelected;
    template.deleteTemplate({
      body: { worktemplate_id },
    });
    setOpenModalDelete(false);
  };

  const handleModalDelete = (workflow) => {
    setWorkflowSelected(workflow);
    setOpenModalDelete(true);
  };

  const handleRunJob = (data) => {
    let { worktemplate_id, name, type } = workflowSelected;

    const jobToRun = new JobSchema();
    jobToRun.setValues({
      userInteraction: data,
      worktemplate_id,
      name,
      type
    });

    job.postJobRun({
      body: { ...jobToRun.values },
    });
    setOpenModalRunJob(false);
  };

  const handleModalRunJob = (workflow) => {
    const definitions = JSON.parse(workflow.wf_definition);

    if (definitions && definitions.length > 0) {
      const definitionsId = definitions.reduce((acum, current, index) => {
        if (index === 0) return acum + `${current[0].id_Plantilla}`;
        else return acum + `,${current[0].id_Plantilla}`;
      }, '');
      setWorkflowSelected(workflow);
      template.getTemplateInteraction({ query: { templateId: definitionsId }});
      setOpenModalRunJob(true);
    }
  };

  const handleCloseModalRunJob = () => {
    setOpenModalRunJob(false);
    template.cleanUp();
  };

  const alerts = [
    {
      severity: 'success',
      open: template.success.post,
      message: 'workflowList.components.alert.success',
    },
    {
      severity: 'success',
      open: template.success.delete,
      message: 'workflowList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: template.success.put,
      message: 'workflowList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: template.error.put,
      message: 'workflowList.components.alert.error',
    },
    {
      severity: 'error',
      open: template.error.delete,
      message: 'workflowList.components.alert.error',
    },
    {
      severity: 'error',
      open: template.error.post,
      message: 'workflowList.components.alert.error',
    },
    {
      severity: 'error',
      open: job.error.post,
      message: 'workflowList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: template.error.getRun,
      message: 'workflowList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: runError,
      message: customError ? customError : (runError === 2 ? 
                'templateList.components.alert.errorJobInventory' :
                'templateList.components.alert.errorJob')
    },
  
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      template.success.post ||
      template.success.put ||
      template.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    template.success.post,
    template.success.put,
    template.success.delete,
  ]);

  useEffect(() => {
    if (job.success.post) {
      if (job.data && job.data.result === 1 && job.data.job_id){
        history.replace(`${ROUTES.JOB_RUN_WORKFLOW}/${job.data.job_id}`);
      } else {
        if (job.data && job.data.mensaje === "Inventario en uso"){
          setRunError(2);
          setCustomError('');
        } else if (job.data && job.data.mensaje.indexOf("Job no encontrado") !== -1 ){
          setRunError(2);
          setCustomError(job.data.mensaje);
        } else {
          setRunError(1);
          setCustomError('');
        }
      }
      
    }

    return () => job.cleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [job.success.post]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={job.isLoaded.post}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      { error ? (
        <ErrorScreen />
      ) : (
        <WorkflowListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleView={handleView}
          handleDelete={handleModalDelete}
          handleRunJob={handleModalRunJob}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            search,
            project: !project ? projects[0].value : project,
          }}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => {template.cleanUpMessage(); setRunError(0);}}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModalDelete}
        handleClose={() => setOpenModalDelete(false)}
        handleConfirm={handleDelete}
      />

      { template.job &&
        <ModalJobAlert
          open={openModalRunJob}
          data={template.job}
          workflowDefinition={workflowSelected ? workflowSelected.wf_definition:[]}
          handleClose={handleCloseModalRunJob}
          handleConfirm={handleRunJob}
        />
      }
    </>
  );
};

export default withRequest(withRouter(WorkflowListSmart));
